'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../../');

var _2 = _interopRequireDefault(_);

var _SwapHoriz = require('material-ui-icons/SwapHoriz');

var _SwapHoriz2 = _interopRequireDefault(_SwapHoriz);

var _Close = require('material-ui-icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _queryBuilder = require('@prisma-cms/query-builder');

var _queryBuilder2 = _interopRequireDefault(_queryBuilder);

var _Drawer = require('material-ui/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Query = (_temp = _class = function (_EditorComponent) {
  _inherits(Query, _EditorComponent);

  function Query(props) {
    _classCallCheck(this, Query);

    var _this = _possibleConstructorReturn(this, _EditorComponent.call(this, props));

    _this.close = function (event) {
      event.preventDefault();
      event.stopPropagation(); // const {
      //   setActiveItem,
      // } = this.getEditorContext();
      // setActiveItem(null);

      _this.setState({
        expanded: false
      });
    };

    _this.state = _extends({}, _this.state, {
      expanded: false
    });
    return _this;
  }

  Query.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_SwapHoriz2.default, null), ' Query'));
  };

  Query.prototype.onClick = function onClick(event) {
    if (event.target === event.currentTarget) {
      var _state = this.state,
          active = _state.active,
          expanded = _state.expanded;

      if (active && !expanded) {
        this.setState({
          expanded: true
        });
      }
    }

    return _EditorComponent.prototype.onClick.call(this, event);
  };

  Query.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var _getEditorContext2 = this.getEditorContext(),
        activeItem = _getEditorContext2.activeItem;

    var output = null;

    var _getComponentProps = this.getComponentProps(this),
        query = _getComponentProps.query;

    var expanded = this.state.expanded;

    if (activeItem && activeItem === this && expanded) {
      // output = <div
      //   style={{
      //     height: "80vh",
      //   }}
      // >
      //   <QueryBuilder
      //     query={query || ""}
      //     onEditQuery={query => {
      //       this.updateComponentProperty("query", query)
      //     }}
      //   />
      // </div>;
      output = _react2.default.createElement(_Drawer2.default, {
        anchor: 'top',
        open: true,
        onClose: this.close // ModalProps={{
        // }}
        ,
        style: {
          // height: "100%",
          zIndex: 3000
        },
        PaperProps: {
          style: {
            height: "100%"
          }
        }
      }, _react2.default.createElement('div', {
        style: {
          textAlign: "right"
        }
      }, _react2.default.createElement(_Button2.default, {
        onClick: this.close
      }, _react2.default.createElement(_Close2.default, null))), _react2.default.createElement(_queryBuilder2.default, {
        query: query || "",
        onEditQuery: function onEditQuery(query) {
          _this2.updateComponentProperty("query", query);
        }
      }));
    } else {
      output = _EditorComponent.prototype.renderChildren.call(this);
    }

    return output;
  };

  return Query;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _class.Name = "Query", _class.help_url = "https://front-editor.prisma-cms.com/topics/query.html", _temp);
exports.default = Query;
module.exports = exports['default'];